/** Enlaces que conservan la ciudad activa.
 *  La ciudad vive en la URL (`?ciudad=avila`); si un enlace la perdiera, el lector saltaría de ciudad
 *  sin pedirlo. Estos envoltorios de Link y NavLink la arrastran salvo que el destino traiga la suya. */
import { Link as RouterLink, NavLink as RouterNavLink, useNavigate, useSearchParams, type LinkProps, type NavLinkProps } from 'react-router-dom';
import { useCallback } from 'react';

export function withCity(to: string, ciudad: string | null): string {
  if (!ciudad || !to.startsWith('/')) return to;
  const [path, query = ''] = to.split('?');
  const sp = new URLSearchParams(query);
  if (!sp.has('ciudad')) sp.set('ciudad', ciudad);
  const s = sp.toString();
  return s ? `${path}?${s}` : path;
}

export function useCityPath(): (to: string) => string {
  const [params] = useSearchParams();
  const ciudad = params.get('ciudad');
  return useCallback((to: string) => withCity(to, ciudad), [ciudad]);
}

export function useCityNavigate(): (to: string) => void {
  const navigate = useNavigate();
  const path = useCityPath();
  return useCallback((to: string) => navigate(path(to)), [navigate, path]);
}

export function Link({ to, ...rest }: Omit<LinkProps, 'to'> & { to: string }) {
  return <RouterLink to={useCityPath()(to)} {...rest} />;
}

export function NavLink({ to, ...rest }: Omit<NavLinkProps, 'to'> & { to: string }) {
  return <RouterNavLink to={useCityPath()(to)} {...rest} />;
}
